"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipWrapper = exports.TooltipTrigger = exports.TooltipBody = exports.TooltipArrow = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _coreMixins = require("@legacy-vfuk/core-mixins");

var _Tooltip = _interopRequireDefault(require("../themes/Tooltip.theme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TooltipWrapper = _styledComponents["default"].span.withConfig({
  displayName: "Tooltipstyle__TooltipWrapper",
  componentId: "sc-o8y7bi-0"
})(function () {
  return (0, _styledComponents.css)(["max-width:288px;", ""], _coreMixins.respondTo.lg((0, _styledComponents.css)(["max-width:320px;"])));
});

exports.TooltipWrapper = TooltipWrapper;

var TooltipTrigger = _styledComponents["default"].span.withConfig({
  displayName: "Tooltipstyle__TooltipTrigger",
  componentId: "sc-o8y7bi-1"
})(function () {
  return (0, _styledComponents.css)(["", ""], (0, _coreMixins.applyFocus)());
});

exports.TooltipTrigger = TooltipTrigger;

var TooltipArrow = _styledComponents["default"].span.withConfig({
  displayName: "Tooltipstyle__TooltipArrow",
  componentId: "sc-o8y7bi-2"
})(function (props) {
  var localTheme = (0, _Tooltip["default"])(props.theme);
  return (0, _styledComponents.css)(["&,&::before{position:absolute;width:10px;height:10px;box-shadow:", "px 4px 4px -4px ", ";z-index:", ";}&::before{content:'';background-color:", ";transform:rotate(45deg);}"], props.theme.elevation.size, props.theme.elevation.color, props.zIndex, localTheme.appearance[props.appearance].backgroundColor);
});

exports.TooltipArrow = TooltipArrow;

var TooltipBody = _styledComponents["default"].div.withConfig({
  displayName: "Tooltipstyle__TooltipBody",
  componentId: "sc-o8y7bi-3"
})(function (props) {
  var localTheme = (0, _Tooltip["default"])(props.theme);
  return (0, _styledComponents.css)(["background-color:", ";color:", ";border-radius:", ";", " ", " z-index:", ";&[data-popper-placement^='top'] > ", "{bottom:-5px;}&[data-popper-placement^='bottom'] > ", "{top:-5px;}", " ", ""], localTheme.appearance[props.appearance].backgroundColor, localTheme.appearance[props.appearance].color, props.theme.border.radius[2], (0, _coreMixins.elevation)(true), (0, _coreMixins.spacing)('padding', 3), props.zIndex, TooltipArrow, TooltipArrow, props.size === 1 && (0, _styledComponents.css)(["", ""], _coreMixins.typography.paragraph(1, false)), props.size === 2 && (0, _styledComponents.css)(["", ""], _coreMixins.typography.paragraph(2, false)));
});

exports.TooltipBody = TooltipBody;
//# sourceMappingURL=Tooltip.style.js.map